module.exports = "/_next/static/images/mtgox-3a8ec394aa9764b633824ff95a37019c.png";